export const LOCAL_AUTH_METHOD = 'local';
export const THIRD_PARTY_AUTH_METHODS = ['google', 'github', 'clever'];
export const ALL_AUTH_METHODS = [LOCAL_AUTH_METHOD, ...THIRD_PARTY_AUTH_METHODS].reduce((o, authMethod) => ({ ...o, [authMethod]: '1' }), {});

// If no auth methods are given then default to allowing all auth methods
export const allowAll = (authMethods) => Object.keys(authMethods).length === 0;

export const hasThirdPartyAuthMethod = (authMethods) =>
  THIRD_PARTY_AUTH_METHODS.some((authMethod) => authMethod in authMethods);
